export default __webpack_public_path__ + "static/motko-background-3ef60db4b2e256a8697f1edcd1d3ac91.png";